import { IApiSubscriptionResponse } from '@/types/models/api_subscription_response';
import { IChangeEmailRequestParams, IChangeEmailVerifyOtpParams, IUpdateUserProfileParams } from '@/types/params/user';
import { IQuotaResponse } from '@/types/models/quota';
import { IMe } from '@/types/models/me';
import { backendAPI } from '@/services/base_api';

export const updateUserProfile = (params: IUpdateUserProfileParams): Promise<any> => {
  return backendAPI('PUT', '/api/users/update-profile', params);
};
export const deleteUser = (userId: string): Promise<any> => {
  return backendAPI('DELETE', `/api/users/${userId}`, {});
};
export const changeEmailVerifyOtp = (formData: IChangeEmailVerifyOtpParams): Promise<any> => {
  return backendAPI('POST', '/api/users/change-email-verify-otp', formData);
};

export const changeEmailRequest = (formData: IChangeEmailRequestParams): Promise<any> => {
  return backendAPI('POST', '/api/users/change-email-request', formData);
};

export const getUserSubscription = (): Promise<any> => {
  return backendAPI('GET', '/api/users/subscription', {});
};

export const getApiSubscription = (): Promise<{ data: IApiSubscriptionResponse }> => {
  return backendAPI('GET', '/api/users/api-subscription', {});
};

export const getUserQuota = (): Promise<{ data: IQuotaResponse }> => {
  return backendAPI('GET', '/api/users/quota', {});
};

export const getMe = (): Promise<{ data: IMe }> => {
  return backendAPI('GET', '/api/users/me', {});
};
